// actions.js
import { serverCall } from 'utils/serverCall';
import {
  initReportRequest,
  addReport,
  errorReportRequest,
  machineByCompanyIdforreport
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';
import { logoutDispatcher } from 'components/login/dispatcher';

export const generateReport = (reportData, setIsLoader) => {
  return async (dispatch) => {
    dispatch(initReportRequest());

    try {
      const result = await serverCall(apiEndpoints.REPORT_CREATE, 'POST', dispatch, reportData);
      if (result.success) {
        const link = document.createElement("a");
        link.href =
          result?.data?.payload?.response;
        // link.download = "Drive-Data.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        dispatch(addReport());
        setTimeout(() => {
          setIsLoader(false)
        }, 2500);

      } else {
        toast.error(result.message);
        dispatch(errorReportRequest(result.message));
        setIsLoader(false)
      }
    } catch (error) {
      setIsLoader(false)
      toast.success(error.message);
      dispatch(errorReportRequest(error.message));
    }
  };
};

export const fetchMachineListByCompanyId = (companyId) => {
  return async (dispatch) => {
    dispatch(initReportRequest());
    try {
      const result = await serverCall(`${apiEndpoints.MACHINE_LIST_BY_COMPANY}/${companyId}`, 'GET', dispatch);

      if (result.success) {
        dispatch(machineByCompanyIdforreport(result?.data?.payload));
      } else {
        dispatch(errorReportRequest(result.message));
      }
    } catch (error) {
      dispatch(errorReportRequest(error.message));
    }
  };
};

export const fetchMachineListForBulkUpload = (companyId, oilType) => {
  return async (dispatch) => {
    dispatch(initReportRequest());
    try {
      let url = `${apiEndpoints.MACHINE_LIST_WITH_OIL_TYPE}?company_id=${companyId}`;
      if (oilType) {
        url += `&oil_type=${oilType}`;
      }
      const result = await serverCall(url, 'GET', dispatch);

      if (result.success) {
        dispatch(machineByCompanyIdforreport(result?.data?.payload));
      } else {
        dispatch(errorReportRequest(result.message));
      }
    } catch (error) {
      dispatch(errorReportRequest(error.message));
    }
  };
};